import { useSelector } from "react-redux";
import Toaster from "../../../../Toast/Toast";
import { useState, useEffect, useRef } from "react";
import NavigationToast from "../../../../Toast/NavigationToast";
import { Card, Tooltip, OverlayTrigger } from "react-bootstrap";
import {ReactComponent as WalletIcon} from "../../../../../assets/icons/walletIcon.svg";
import { togglePayment } from "../../../../../redux/slices/accountSlice";
import { useDispatch } from "react-redux";

const WithdrawCard = ({
  data,
  hidemodal,
  totalPrice,
  setTotalPrice,
  handleNextClick,
  setSelectedItems,
}) => {
  const toastTimeout = useRef(null);
  const [quantities, setQuantities] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [navigationToast, setNavigationToast] = useState({
    error: "",
    success: "",
    redirectTo: "",
  });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const [selectedItemIndexes, setSelectedItemIndexes] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.length) {
      const initialQuantities = {};
      data.forEach((item) => {
        initialQuantities[item.id] = item.quantity || 1;
      });
      setQuantities(initialQuantities);
    }
  }, [data]);

  const handleCardClick = (item, index) => {
    const isItemSelected = selectedItemIndexes.includes(index);
    if (isItemSelected) {
      setSelectedItemIndexes(
        selectedItemIndexes.filter((idx) => idx !== index),
      );
      setSelectAll(false);
    } else {
      setSelectedItemIndexes([...selectedItemIndexes, index]);
      if (selectedItemIndexes.length + 1 === data?.length) {
        setSelectAll(true);
      }
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItemIndexes([]);
    } else {
      setSelectedItemIndexes(data.map((_, index) => index));
    }
    setSelectAll(!selectAll);
  };

  const handleDivClick = (selectedItemIndexes) => {
    const selectedItems = selectedItemIndexes.map((index) => ({
      ...data[index],
      quantity: quantities[data[index]?.id],
    }));

    setSelectedItems(selectedItems);
    handleNextClick(selectedItems);
  };

  const showToastOnce = (msg, isError = false) => {
    if (toastTimeout.current) return;

    if (msg === "Please verify your profile before withdrawing.") {
      setNavigationToast({
        error: msg,
        success: "",
        redirectTo: "/myaccount/documents",
      });
      hidemodal();
    } else {
      setToastMessage(isError ? { error: msg } : { success: msg });
    }

    toastTimeout.current = setTimeout(() => {
      setToastMessage("");
      setNavigationToast({ success: "", error: "" });
      toastTimeout.current = null;
    }, 2000);
  };

  const incrementQuantity = (itemId, maxQuantity) => {
    setQuantities((prev) => {
      const current = prev[itemId] || 1;
      if (current >= maxQuantity) {
        showToastOnce("You've reached the maximum available quantity.", true);
        return prev;
      }
      return { ...prev, [itemId]: current + 1 };
    });
  };

  const decrementQuantity = (itemId) => {
    setQuantities((prev) => {
      const current = prev[itemId] || 1;
      if (current <= 1) {
        showToastOnce("Quantity cannot be less than 1.", true);
        return prev;
      }
      return { ...prev, [itemId]: current - 1 };
    });
  };

  useEffect(() => {
    const newTotalPrice = selectedItemIndexes.reduce((total, index) => {
      const item = data[index];
      const qty = quantities[item?.id] || item.quantity || 1;
      return total + parseFloat(item?.price) * qty;
    }, 0);
    setTotalPrice(newTotalPrice);
  }, [selectedItemIndexes, quantities, data]);

  return (
    <>
      {navigationToast?.error ? (
        <NavigationToast message={navigationToast} />
      ) : (
        <Toaster message={toastMessage} />
      )}

      <div className="mt-1 mb-2 d-space-between px-lg-4 px-md-0">
        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "flex-start",
          }}
          className="p-lg-2 p-md-0"
        >
          <div style={{ flexShrink: 0, alignSelf: "center" }}>
            <WalletIcon style={{ width: 40, height: 40, color: "#facc15" }} />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "24px",
                fontWeight: 600,
                color: "white",
              }}
            >
              Withdraw
            </span>
            <span style={{ fontSize: "14px", color: "#9ca3af" }}>
              Select items to withdraw
            </span>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            id="selectAllCheckbox"
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ width: "14px", height: "14px", cursor: "pointer" }}
          />
          <label
            htmlFor="selectAllCheckbox"
            className={`selectall-txt ms-1 mb-0 cursor-pointer ${
              isDarkMode ? "deposit-heading-dark" : "deposit-heading-light"
            }`}
            style={{
              fontSize: "14px",
              fontWeight: "400",
              color: isDarkMode ? "#A6A6A6" : "rgba(73, 69, 79, 1)",
            }}
          >
            {selectAll ? "Unselect All" : "Select All"}
            (${totalPrice?.toFixed(2)})
          </label>
        </div>
      </div>

      <div className={`card-main-withdraw ${isDarkMode ? "dark" : "light"}`}>
        {data?.map((item, index) => {
          const isHovered = hoveredIndex === index;
          const isSelected = selectedItemIndexes.includes(index);
          const currentQty = quantities[item?.id] ?? item.quantity ?? 1;

          return (
            <Card
              key={index}
              onClick={() => handleCardClick(item, index)}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className={`withdraw-product-card-main ${
                isDarkMode
                  ? "withdraw-product-card-main-dark"
                  : "withdraw-product-card-main-light"
              }`}
              style={{ background: isSelected ? "#302B1A" : "#262626" }}
            >
              <div
                className={`${
                  isDarkMode
                    ? "withdraw-product-card-inner-dark"
                    : "withdraw-product-card-inner-light"
                }`}
              >
                {/* Checkbox hidden but functional */}
                <input
                  readOnly
                  type="checkbox"
                  checked={isSelected}
                  style={{ display: "none" }}
                />

                {/* Badge: yellow checkmark when selected, red quantity when not */}
                <div
                  className={`${
                    isSelected ? "quantity-badge-selected" : "quantity-badge"
                  }`}
                >
                  {isSelected ? "✓" : currentQty}
                </div>

                {isSelected && (
                  <div className="withdraw-quantity-controls">
                    <button
                      className="qty-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        decrementQuantity(item.id);
                      }}
                    >
                      −
                    </button>
                    <span className="qty-number">{currentQty}</span>
                    <button
                      className="qty-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        incrementQuantity(item.id, item.quantity);
                      }}
                    >
                      +
                    </button>
                  </div>
                )}

                <div className="withdraw-card-img">
                  <img
                    variant="top"
                    src={
                      item?.box_images ? item?.box_images?.image : item?.image
                    }
                    alt="Card Image"
                    className="card-img-withdraw"
                  />
                </div>
              </div>

              <div className="ps-2" style={{ padding: "0px" }}>
                <Card.Title
                  className={`withdraw-card-title text-AktivGrotesk-Medium  mt-1 ${
                    isDarkMode ? "text-lavender-gray" : ""
                  }`}
                >
                  {item?.name}
                </Card.Title>
                <Card.Text
                  className={`withdraw-card-text mt-1 ${
                    isDarkMode ? "text-white" : "text-deep-purple"
                  }`}
                >
                  ${item?.price}
                </Card.Text>
              </div>
            </Card>
          );
        })}
      </div>

      <hr
        className={`withdraw-modal-horizontal-line m-0 opacity-100 ${isDarkMode ? "dark" : "light"}`}
      />

      <div className="withdraw-bitcoin-footer mt-2 px-4">
        <div
          className={`withdraw-bitcoin-footer-div ${
            isDarkMode ? "deposit-heading-dark" : "deposit-heading-light"
          }`}
          style={{ color: isDarkMode ? "#A6A6A6" : "#000" }}
        >
          {selectedItemIndexes?.reduce(
            (total, index) => total + (quantities[data[index]?.id] || 1),
            0,
          )}{" "}
          items selected - Total ${totalPrice?.toFixed(2)}
        </div>

        <OverlayTrigger
          placement="top"
          overlay={
            selectedItemIndexes.length === 0 ? (
              <Tooltip id="tooltip-select">Select an item first</Tooltip>
            ) : (
              <span></span>
            )
          }
          trigger={["hover", "focus", "click"]}
        >
          <span className="w-30 w-md-100 d-inline-block d-flex gap-2">
            <button
              onClick={() => dispatch(togglePayment())}
              ref={(el) => {
                if (el) el.style.setProperty("height", "48px", "important");
              }}
              className={`w-50 text-18px text-fw-700 pt-2
                ${
                  isDarkMode
                    ? "deep-primary-monochrome-btn-dark"
                    : "outlined-medium-deep-purple-btn-light"
                }`}
            >
              Cancel
            </button>
            <button
              disabled={selectedItemIndexes.length === 0}
              className={`w-50 ${
                isDarkMode
                  ? "box-modal-button"
                  : "filled-medium-deep-purple-btn-light"
              } ${
                selectedItemIndexes.length === 0
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              }`}
              onClick={() => handleDivClick(selectedItemIndexes)}
              style={{ opacity: selectedItemIndexes.length === 0 ? 0.5 : 1 }}
            >
              Next{" "}
              <span>
                <svg
                  style={{ marginBottom: "3px" }}
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="black"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 4 14 12 6 20" />
                  <polyline points="12 4 20 12 12 20" />
                </svg>
              </span>
            </button>
          </span>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default WithdrawCard;